import EventList from '@/components/events/EventList'

const PreviousEvents = () => {
  return <EventList />
}

export default PreviousEvents
